export const GENERIC_VERIFICATION_ERROR =
    "We couldn't verify that code. Request a new code and try again. If this keeps happening, email support@join-tandem.com.";

export const GENERIC_VERIFICATION_SEND_ERROR =
    "We couldn't send your code. Try again in a few minutes. If this keeps happening, email support@join-tandem.com.";

export function verificationErrorMessage(error: unknown, fallback: string = GENERIC_VERIFICATION_ERROR): string {
    if (!error || typeof error !== 'object') return fallback;
    const data = error as Record<string, unknown>;
    for (const key of ['message', 'detail', 'error']) {
        const value = data[key];
        if (typeof value === 'string' && value) return value;
    }
    return fallback;
}
